import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { SystemBreakdown } from './components/SystemBreakdown';
import { VisualHandbooks } from './components/VisualHandbooks';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { WhySystem } from './components/WhySystem';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: MetaPixel;
};
type MetaWindow = Window & {
  fbq?: MetaPixel;
  _fbq?: MetaPixel;
};
const META_PIXEL_ID = '1651357612587495';
export function App() {
  useEffect(() => {
    const w = window as MetaWindow;
    try {
      if (!w.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as MetaPixel;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        w.fbq = pixel;
        w._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-acad-canvas text-acad-ink" data-id="element-0" data-mp="studrrrxgr8h">
      <noscript data-id="element-1" data-mp="36859fxwiety">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="35ymodf6r9ya" />
      </noscript>
      <main data-id="element-3" data-mp="d3wbb20yj8rf">
        <Hero data-id="element-4" data-mp="d2bj3j2481wq" />
        <PainPoints data-id="element-5" data-mp="85l0op2u8u85" />
        <SolutionReveal data-id="element-6" data-mp="85bb32lpgp2z" />
        <VolumesSection data-id="element-7" data-mp="86w3alkjrvxo" />
        <SystemBreakdown data-id="element-8" data-mp="83i0xdbvvmq8" />
        <VisualHandbooks data-id="element-9" data-mp="3gl4r7gc4jyji" />
        <BonusSection data-id="element-10" data-mp="3gmfwxlp4rgd9" />
        <PricingSection data-id="element-11" data-mp="3glwabrojc3sw" />
        <WhySystem data-id="element-12" data-mp="3gj1r23h9cp12" />
        <Testimonials data-id="element-13" data-mp="3bmjs5k8lzkwn" />
        <Guarantee data-id="element-14" data-mp="3bncpxvplb02n" />
        <FAQ data-id="element-15" data-mp="3bnuudfmeokln" />
        <FinalCTA data-id="element-16" data-mp="3bo4isyrsyjp8" />
      </main>
      <Footer data-id="element-17" data-mp="3qaxs9nen4v9i" />
    </div>;
}